export default {
  GET_LENOVO_LANGUAGE: 'GET_LENOVO_LANGUAGE',
  GET_USER_INFO: 'GET_USER_INFO',
  GET_LENOVO_ACCOUNT_INFO: 'GET_LENOVO_ACCOUNT_INFO',
  GET_LENOVO_CUSTOMIZE_INFO: 'GET_LENOVO_CUSTOMIZE_INFO',
  GET_SESSION: 'GET_SESSION',
  // 企业版管理员角色
  GET_USER_ROLE: 'TYPES.GET_USER_ROLE',
  SET_SEARCH_CANCEL: 'SET_SEARCH_CANCEL',
  // 验证码状态框
  GET_SESSION_ID: 'GET_SESSION_ID',
  // license相关
  GET_LICENSE_INFO: 'GET_LICENSE_INFO',
  GET_BOX_USER_INFO: 'GET_BOX_USER_INFO',
  GET_BOX_Type: 'GET_BOX_Type',
  GET_SPECIAL_VERSION: 'GET_SPECIAL_VERSION',
}



// WEBPACK FOOTER //
// ./store/types.js